/* eslint-disable no-param-reassign */
import { AxiosRequestConfig } from 'axios';

/** 登陆失效标识头信息 */
const SESSION_OUT_HEADER = 'session-out';

/**
 * 设置请求头信息
 * @param config
 * @param key
 * @param value
 */
export function setHeader(config: AxiosRequestConfig, key: string, value: string) {
  config.headers = config.headers || {};
  config.headers[key] = value;
}

/**
 * 获取指定的请求头信息
 * @param config
 * @param key
 * @returns
 */
export function getHeader(config: AxiosRequestConfig, key: string) {
  const headers = config.headers || {};
  return headers[key] || '';
}

/**
 * 设置登陆失效后的请求头标识
 * @param config
 */
export function setSessionOutHeader(config: AxiosRequestConfig) {
  setHeader(config, SESSION_OUT_HEADER, '1');
}

/**
 * 获取登陆失效请求头标识
 * @param config
 * @returns
 */
export function getSessionOutHeader(config: AxiosRequestConfig) {
  return getHeader(config, SESSION_OUT_HEADER);
}

